export default __webpack_public_path__ + "static/media/jee_model_web.7887b847.png";